<template>
  <v-dialog v-model="dialog" persistent width="1200">
    <v-card style="max-height: none; overflow: hidden">
      <v-row class="redColor justify-end pa-4 pb-2">
        <v-btn variant="outlined" icon @click="dialog = false">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-row>
      <!--------------------------------------------CAR-------------------------------------------->
      <v-row class="pa-2">
        <v-col>
          <v-row class="d-flex">
            <!--BRAND-->
            <v-col class="caption d-flex flex-column">
              {{ $t("part_requests.car.brand") }}:
              <span v-if="car.brand" class="font-weight-bold">
                {{ car.brand.title }}
              </span>
            </v-col>
            <!--MODEL-->
            <v-col class="caption d-flex flex-column">
              {{ $t("part_requests.car.model") }}:
              <span v-if="car.model" class="font-weight-bold">
                {{ car.model.description }}
              </span>
            </v-col>
          </v-row>
          <v-row v-if="car.version">
            <!--VERSION-->
            <v-col>
              <div class="caption">{{ $t("part_requests.car.version") }}:</div>
              <div class="font-weight-bold">
                {{ car.version.description }}
              </div>
            </v-col>
            <v-col>
              <div class="caption">{{ $t("part_requests.car.year") }}:</div>
              <div class="font-weight-bold">
                {{ formatMonthYear(car.version.startingDate) }} -
                {{ formatMonthYear(car.version.endingDate) }}
              </div>
            </v-col>
            <v-col>
              <div class="caption">{{ $t("part_requests.car.body") }}:</div>
              <div class="font-weight-bold">
                {{ car.version.numberOfDoors }}
              </div>
            </v-col>
            <v-col>
              <div class="caption">{{ $t("part_requests.car.power") }}:</div>
              <div class="font-weight-bold">{{ car.version.power.kw }} kw</div>
            </v-col>
            <!--
            <v-col>
              <div class="caption">
                {{ $t('part_requests.car.engine') }}:
              </div>
              <div class="font-weight-bold">
                {{ car.version.engine }}
              </div>
            </v-col>
            -->
            <v-col>
              <div class="caption">{{ $t("part_requests.car.supply") }}:</div>
              <div class="font-weight-bold">
                {{ getSupplyLocale(car.version.supplyCode) }}
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-spacer />
        <v-col>
          <!--PERMIT-->
          <v-row column align-start justify-center>
            <div class="caption">{{ $t("part_requests.permit") }}:</div>
            <img
              style="max-width: 130px"
              class="pointer"
              :src="
                permit && permit.value
                  ? `${server}/images/part-request?q=${user.id}-${permit.title}`
                  : logo
              "
              block
              @click="viewPermitImage"
            />
          </v-row>
        </v-col>
      </v-row>
      <!-----------------------------------------REQUESTS------------------------------------------>
      <v-row class="mt-3 pa-2">
        <v-col v-for="(request, r) in requests" :key="r" xs="12" sm="6" md="4">
          <v-card class="ma-1">
            <v-row class="d-flex flex-column">
              <!--IMAGES-->
              <v-col xs="12">
                <v-carousel height="250" class="pointer">
                  <v-carousel-item
                    v-for="(image, i) in request.images"
                    :key="i"
                    :src="`${server}/images/part-request?q=${request.id}-${image}`"
                    @click="viewRequestImages(request)"
                  />
                </v-carousel>
              </v-col>
              <v-col class="mt-2ml-2 mr-2" xs="12">
                <div class="caption">
                  {{ $t("part_requests.request.code") }}:
                </div>
                <div class="title">
                  {{ request.code }}
                </div>
              </v-col>
              <v-col class="mb-2 ml-2 mr-2" xs="12">
                <div class="caption">
                  {{ $t("part_requests.request.description") }}:
                </div>
                <div class="font-weight-bold">
                  {{ request.description }}
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <!-------------------------------------------USER-------------------------------------------->
      <div class="body-1 mt-3 pa-2">
        {{ $t("part_requests.user.users_details") }}:
      </div>
      <v-row v-if="user.details" class="pa-2">
        <v-col>
          <div class="caption">{{ $t("part_requests.user.name") }}:</div>
          <div class="subheading font-weight-medium">
            {{ user.details.name }}
          </div>
        </v-col>
        <v-col>
          <div class="caption">{{ $t("part_requests.user.surname") }}:</div>
          <div class="subheading font-weight-medium">
            {{ user.details.surname }}
          </div>
        </v-col>
        <v-col>
          <div class="caption">{{ $t("part_requests.user.address") }}:</div>
          <div class="subheading font-weight-medium">
            {{ user.details.address }}
          </div>
        </v-col>
        <v-col>
          <div class="caption">{{ $t("part_requests.user.phone") }}:</div>
          <div class="subheading font-weight-medium">
            {{ user.details.phone }}
          </div>
        </v-col>
        <v-col>
          <div class="caption">{{ $t("part_requests.user.email") }}:</div>
          <div class="subheading font-weight-medium">
            {{ user.details.email }}
          </div>
        </v-col>
      </v-row>
      <!------------------------------------------------------------------------------------------->
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import logo from "../../assets/logo_small.png";

export default {
  data: () => ({
    logo,
    dialog: false,
    pagination: {
      rowsPerPage: 4,
    },
    requests: [],
    car: {},
    user: {},
    permit: { value: false, title: null },
  }),
  computed: {
    server() {
      return this.$serverUri;
    },
  },
  watch: {},
  methods: {
    open(data) {
      this.dialog = true;
      this.requests = data.requests;
      this.car = data.car;
      this.user = data.user;
      this.permit = data.permit;
    },
    close() {
      this.requests = [];
      this.car = {};
      this.user = {};
      this.permit = { value: false, title: null };
    },
    hide() {
      this.dialog = false;
    },
    show() {
      this.dialog = true;
    },
    viewPermitImage() {
      this.$emit("view-permit-image", {
        id: this.user.id,
        title: this.permit.title,
      });
    },
    viewRequestImages(request) {
      this.$emit("view-request-images", {
        id: request.id,
        images: request.images,
      });
    },
    getSupplyLocale(supply) {
      switch (supply) {
        case "B":
          return this.$t("parts.infoCar.supply.petrol");
        case "D":
          return this.$t("parts.infoCar.supply.diesel");
        case "G":
          return this.$t("parts.infoCar.supply.gas");
        default:
          return supply;
      }
    },
    formatMonthYear(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // months are 0-indexed
      const year = date.getUTCFullYear();
      return `${month}/${year}`;
    },
  },
};
</script>
